// Shared classNames for order-form dropdowns styled as plain text rather than
// a boxed control — same treatment as the quote-asset/instrument-kind Select
// triggers (border-none, shrink-to-content, underline only on hover). Used by
// both account dropdowns (order-preview-panel's preview selector and
// unified-order-form's per-exchange account filter) so the two stay visually
// identical instead of drifting into separately-tuned one-offs.
// The open state needs its own explicit rounded/tinted treatment (matching
// the reduce/post-only buttons' active look) — otherwise the base Select
// trigger's own `data-[state=open]:bg-*` leaks through with none of its
// padding (canceled by the padding below, since that's an unconditional
// override) and no border, reading as a stray light smudge with rounded
// corners rather than an intentional active state. Padding is reserved
// UNCONDITIONALLY (not only in the open state) so the open/tinted look only
// ever toggles a background/text color, never the box's own size — sizing it
// only on open made the trigger visibly grow/shift everything next to it the
// instant it opened.
export const INLINE_SELECT_TRIGGER =
  'h-auto w-auto cursor-pointer border-none bg-transparent px-2 py-1 text-xs font-medium text-foreground/70 transition-colors hover:text-foreground hover:underline disabled:opacity-50 data-[state=open]:bg-foreground/10 data-[state=open]:text-foreground data-[state=open]:no-underline'

export const INLINE_SELECT_CONTENT = 'z-[60] border-none bg-popover p-1'

export const INLINE_SELECT_ITEM = 'hover:bg-foreground/5 cursor-pointer px-2 py-1.5 text-sm'
